import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { placeCreatedRowFirst } from "utils/helpers";
import { initialFormState, initialState } from "./initialState";
import { supplierTableRow, supplierFormState } from "../types"

export const sliceKey = "SupplierState";

export const supplierSlice = createSlice({
      name: sliceKey,
      initialState: initialState,
      reducers: {
            getSupplierList: (state)=>{
                  state.loading = true
            },
            getSupplierSuccess: (state,action: PayloadAction<supplierTableRow[]>)=>{
                  state.loading = false
                  state.data = action.payload
            },
            getSupplierFailure: (state)=>{
                  state.loading = false
            },

            setFormField: (state, action: PayloadAction<Partial<supplierFormState>>) => {
                  state.form = { ...state.form, ...action.payload }
            },
            openAddModal: (state) => { state.isAddModalOpen = true },
            closeAddModal: (state) => { state.isAddModalOpen = false },
            resetForm: (state) => { state.form = initialFormState },
            craeteSupplier: (state, action: PayloadAction<supplierFormState>) => {
                  state.form = action.payload
                  state.loading = true
            },

            createSupplierSuccess: (state, action: PayloadAction<supplierTableRow>) => {
                  state.loading = false
                  state.data = placeCreatedRowFirst(state.data, action.payload)
                  state.form = initialFormState
            },
            createSupplierFailure: (state) => {
                  state.loading = false
            },
      }
})

export const { reducer, actions } = supplierSlice